import { render, staticRenderFns } from "./MomMassagesPrices.vue?vue&type=template&id=e20c74ac&"
import script from "./MomMassagesPrices.vue?vue&type=script&lang=js&"
export * from "./MomMassagesPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports